import useWinCheckAverage, { winCheckAverageConfigs } from './useCheckAverage'
import useWinSales, { winSalesConfigs } from './useSales'
import useWinSss, { winSssConfigs } from './useSss'

export const configs = {
  winSales: winSalesConfigs,
  winSss: winSssConfigs,
  winCheckAverage: winCheckAverageConfigs,
}

export const api = {
  winSales: useWinSales,
  winSss: useWinSss,
  winCheckAverage: useWinCheckAverage,
}
